(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dogtopus-video-strip"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => document.querySelectorAll('.vl-purchase-videos').forEach(root => {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const videos=[...root.querySelectorAll('video')];
    root.querySelectorAll('[data-vl-purchase-play]').forEach(button => {
      const video=button.parentElement.querySelector('video');
      const sync=() => {button.querySelector('span').textContent=video.paused?'▶':'Ⅱ';button.setAttribute('aria-label',(video.paused?button.dataset.playLabel:button.dataset.pauseLabel)+': '+video.getAttribute('aria-label'));};
      video.addEventListener('play',sync);video.addEventListener('pause',sync);
      button.addEventListener('click',async()=>{
        if(video.paused){videos.forEach(other=>{if(other!==video)other.pause();});if(!video.getAttribute('src'))video.src=video.dataset.videoSrc;try{await video.play();}catch{video.controls=true;}}else video.pause();
      });
    });
    if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(!e.isIntersecting)e.target.pause();}),{threshold:.15});videos.forEach(v=>observer.observe(v));}
  });
  setup();document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

})();
